<template>
  <div>
    <el-form ref="formRef" :model="priceForm" label-width="180px">
      <el-form-item label="金币数量：">
        <el-input v-model="priceForm.num" placeholder="请输入金币数量" style="width:25em;"/>
      </el-form-item>
      <el-form-item label="打折前的价格：">
        <el-input v-model="priceForm.oldPrice" placeholder="请输入打折前价格" style="width:25em;"/>
      </el-form-item>
      <el-form-item label="打折后的价格：">
        <el-input v-model="priceForm.newPrice" placeholder="请输入打折后价格" style="width:25em;"/>
      </el-form-item>
      <el-form-item label="折扣：">
        <el-input v-model="priceForm.discount" placeholder="正整数，请输入折扣" style="width:25em;"/>
      </el-form-item>
      <el-form-item label="排序：">
        <el-input type="number" v-model.number="orderNum" min="1" placeholder="数字越大越靠前" style="width:25em;"/>
      </el-form-item>
      <el-form-item label="状态：">
        <el-select v-model="state" placeholder="Select" style="width: 10em">
          <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="平台：">
        <el-select v-model="platformType" placeholder="Select" style="width: 10em" @change="platformTypeChange" :disabled="idx > -1">
          <el-option v-for="item in platformTypeArray" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="包名：">
        <el-select v-model="packageNameId" placeholder="Select" :disabled="idx > -1">
          <el-option v-for="item in packageNameArray" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="渠道：">
        <el-input v-model="priceForm.channel" placeholder="请输入渠道" style="width:25em;" :disabled="platformType == 1 || platformType == 4"/>
      </el-form-item>
      <el-form-item label="productId：" v-show="platformType == 2">
        <el-input v-model="priceForm.productId" placeholder="请输入productId" style="width:25em;"/>
      </el-form-item>
      <el-form-item label="金币展示：">
        <el-select v-model="showType" placeholder="Select" style="width: 10em">
          <el-option v-for="item in showTypeArray" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
      <div class="dialog-footer" style="text-align: center">
        <el-button @click.native="cancel" >取消</el-button>
        <el-button type="primary" @click="submit">确定</el-button>
      </div>
  </div>

</template>

<script>
import { postFormData } from "@/api/api"
import { addOrUpdateGoldPrice } from "@/api/url";
import { positiveIntReg } from "@/assets/shared/reg-constant";

export default {
  name: "UserFromDialog",
  props: {
    value: Object
  },
  data() {
    return {
      priceForm: this.value.priceForm,
      idx: this.value.ids,
      state: this.value.ids > -1? this.value.priceForm.state: 0,
      packageNameId: this.value.ids > -1? this.value.priceForm.packageNameId: 0,
      orderNum: this.value.ids > -1? this.value.setsForm.orderNum: 1,

      stateArray: [
        {label:'生效', value:0},
        {label:'下架', value:1},
      ],

      platformTypeArray: [
        {label:'Android', value:1},
        {label:'鸿蒙', value:4},
        {label:'IOS', value:2},
      ],
      platformType: this.value.priceForm.platformType?this.value.priceForm.platformType:1,

      channelPackageList: this.value.channelPackageList,
      packageNameArray: [{label:'不限', value: 0}],

      // 金币展示
      showTypeArray: [
        {label: '全部展示', value: -1},
        {label: '仅购买页面展示', value: 1},
        {label: '仅弹框展示', value: 2}
      ],
      showType: this.value.ids > -1? this.value.priceForm.showType:-1,
    }
  },
  methods: {

    platformTypeChange(val) {
      if(val == 1 || val == 4) {
        this.priceForm.channel = 'app'
      }else {
        this.priceForm.channel = ''
        this.priceForm.productId = ''
      }

      this.packageNameArray = [{label:'不限', value: 0}];
      this.channelPackageList.map(item=>{
        if(item.platformType == val) {
          let obj = {}
          obj.label = item.packageName
          obj.value = item.id
          this.packageNameArray.push(obj)
        }
      })
    },

    cancel() {
      this.$emit("close");
    },
    submit() {
      if(!this.priceForm.num) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '金币数量不能为空',
          type: 'warning'
        });
        return false
      }else if(!positiveIntReg.test(this.priceForm.num)) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请正确输入金币数量',
          type: 'warning'
        });
        return false
      }
      if(!this.priceForm.newPrice) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请输入打折后价格',
          type: 'warning'
        });
        return false
      }
      if(!this.orderNum) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '排序不能为空或小于0',
          type: 'warning'
        });
        return false
      }
      if(this.platformType == 2 && !this.priceForm.channel) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请输入渠道',
          type: 'warning'
        });
        return false
      }
      if(this.platformType == 2 && !this.priceForm.productId) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请输入productId',
          type: 'warning'
        });
        return false
      }
      let param = {}
      param['id'] = this.idx == -1?0: this.priceForm.id;
      param['channel'] = this.priceForm.channel;
      param['productId'] = this.priceForm.productId;
      param['num'] = this.priceForm.num;
      param['oldPrice'] = this.priceForm.oldPrice?this.priceForm.oldPrice:0;
      param['newPrice'] = this.priceForm.newPrice;
      param['discount'] = this.priceForm.discount;
      param['state'] = this.state;
      param['orderNum'] = this.orderNum;
      param['showType'] = this.showType;
      param['platformType'] = this.platformType;
      param['packageNameId'] = this.packageNameId;
      postFormData(addOrUpdateGoldPrice, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', param)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    }
  },
  
  mounted() {
    if(this.idx == -1) {
      this.priceForm.channel = 'app'
    }

    this.channelPackageList.map(item=>{
      if(item.platformType == this.platformType) {
        let obj = {}
        obj.label = item.packageName
        obj.value = item.id
        this.packageNameArray.push(obj)
      }
    })
  }
}
</script>

<style scoped>

</style>
